// react
import React from "react";
// toast
import 'react-toastify/dist/ReactToastify.css';
// error
import { onError } from "../../../features/error/error.tsx";
import { CreateOrUpdatePlans } from "../../../controllers/admin/plans/createOrUpdatePlans.tsx";
const CreatePlans = () => {
    const { register, handleSubmit, pending, pendingUpdate, onSubmit, id } = CreateOrUpdatePlans();
    return (
        <>
            <section>
                {/* admin page component */}
                <div className={'admin-page-content mb-3 pt-0'}>
                    <div id={'admin-page-form'}>
                        <p className={'fw-bold box-title'}>
                            {id ? 'اپدیت پلن' : 'ایجاد پلن'}
                        </p>
                        <div className={'card card-body shadow border-0'}>
                            <form onSubmit={handleSubmit(onSubmit, onError)}>
                                <div className="row align-items-center gy-4">
                                    <div className="col-md-6">
                                        <fieldset className='form-floating'>
                                            <input
                                                type='text'
                                                placeholder='عنوان'
                                                className='form-control'
                                                {...register('title', { required: 'فیلد عنوان الزامی است.' })}
                                            />
                                            <label className='form-label'>
                                                عنوان
                                            </label>
                                        </fieldset>
                                    </div>
                                    <div className="col-md-6">
                                        <fieldset className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="قیمت"
                                                {...register('price', { required: 'فیلد قیمت الزامی است' })}
                                            />
                                            <label >قیمت</label>
                                        </fieldset>
                                    </div>
                                    <div className="col-12">
                                        <fieldset className='form-floating'>
                                            <textarea className="form-control" placeholder="توضیحات"
                                                {...register('options', { required: 'فیلد توضیحات الزامی است' })} ></textarea>
                                            <label className='form-label'>
                                                توضیحات
                                            </label>
                                        </fieldset>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-start">
                                    <button disabled={id ? pendingUpdate : pending} className='btn btn-outline-primary mt-4'>
                                        {pendingUpdate || pending ? 'در حال ارسال ...' : 'ارسال'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default CreatePlans;